// In-house MVT student leaderboard (app/views/v2/leaderboards/*).
//
// Sorting, searching and pagination are server-side and URL-driven; the only
// client-side behavior is a progressive enhancement that auto-submits the
// "rows per page" selector on change, so changing the page size does not need
// an extra "apply" button. The surrounding GET form still works without JS.
$(document).on('turbolinks:load', function() {
  $('#leaderboard-per-page').on('change', function() {
    if (this.form) this.form.submit();
  });
});
